import { createRouter, createWebHistory } from 'vue-router'
import { buildBizChildrenRoutes } from './biz-routes'
// import store from "@/store";
// import {message} from "ant-design-vue";

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index-frame.vue'),
    meta: {
      loginRequire: true,
      cache: false
    },
    children: [
      {
        path: 'user/',
        component: () => import('../views/user/user-main.vue'),
        meta: {
          loginRequire: true,
          cache: false
        },
        redirect: '/user/account',
        children: [
          {
            path: 'account',
            component: () => import('../views/user/user-account.vue')
          },
          {
            path: 'function',
            component: () => import('../views/user/user-function.vue')
          },
          {
            path: 'api',
            component: () => import('../views/user/user-api.vue')
          },
          {
            path: 'role',
            component: () => import('../views/user/user-role.vue')
          }
        ]
      },
      {
        path: 'biz/',
        component: () => import('../views/biz/biz-main.vue'),
        meta: {
          loginRequire: true,
          cache: false
        },
        redirect: '/biz/member/list',
        children: buildBizChildrenRoutes()
      },
      {
        path: 'index-main',
        component: () => import('../views/index/index-main.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login-page.vue')
  },{
    path: '/logout',
    name: 'logout',
    component: () => import('../views/logout-page.vue')
  },{
    path: '',
    redirect: '/index-main'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
